import { helper } from '@ember/component/helper';

/**
 * Filtra una collezione e restituisce le label come stringa separata da virgole
 */
var collectionList = helper(function collectionList([collection, filterKey, filterValue]) {
  if (!Array.isArray(collection) || collection.length === 0) return '';

  // Usa != null: supporta filterValue=0 e filterValue=false
  const shouldFilter = filterKey != null && filterValue != null;
  const filteredCollection = shouldFilter ? collection.filter(item => item?.get?.(filterKey) === filterValue) : collection;
  const labels = [];
  for (const item of filteredCollection) {
    if (item?.label) labels.push(item.label);
  }
  return labels.join(', ');
});

export { collectionList as default };
//# sourceMappingURL=collection-list.js.map
